var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWord({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-82.4%",
    y: "-58.8%",
    width: "264.7%",
    height: "264.7%",
    filterUnits: "objectBoundingBox",
    id: "a"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M0 5h8.5v8.5H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.84 0h-9.4A.43.43 0 0 0 3 .43v17.14c0 .23.18.43.44.43h13.12c.23 0 .44-.18.44-.43V4.05a.42.42 0 0 0-.12-.3L13.14.12a.5.5 0 0 0-.3-.11Z",
    fill: "#EBF0F3",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.44 3.87h3.51c-.02-.05-.04-.09-.09-.11L15 1.93 13.14.11l-.11-.09v3.42c-.03.25.18.43.41.43Z",
    fill: "#D5D6DB",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#a)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#23559B",
    xlinkHref: "#b"
  })), /*#__PURE__*/React.createElement("text", {
    fontFamily: "SourceSansPro-Semibold, Source Sans Pro",
    fontSize: 8,
    fontWeight: 500,
    letterSpacing: 0.05,
    fill: "#FFF",
    transform: "translate(2)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1,
    y: 12
  }, "W")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWord);
export default __webpack_public_path__ + "static/media/Word.7ce5628fbce46bbe416ce139671163df.svg";
export { ForwardRef as ReactComponent };